import axios from 'axios';
import auth from '../components/auth';

export const ChatApi = {
  getCreatorChatToken: async () => {
    const endpoint = `${import.meta.env.VITE_MUX_API_URL}/chat/creator/token`;

    const token = auth.getToken();

    const {
      data: { data },
    } = await axios.post(
      endpoint,
      {},
      {
        headers: {
          Authorization: token,
        },
      },
    );

    return data.token;
  },
  getModeratorChatToken: async ({ creatorId }) => {
    const endpoint = `${import.meta.env.VITE_MUX_API_URL}/chat/moderator/token`;

    const token = auth.getToken();

    const {
      data: { data },
    } = await axios.post(
      endpoint,
      { creatorId },
      {
        headers: {
          Authorization: token,
        },
      },
    );

    return data.token;
  },
  getAdminChatToken: async () => {
    const endpoint = `${import.meta.env.VITE_MUX_API_URL}/chat/admin/token`;

    const token = auth.getToken();

    const {
      data: { data },
    } = await axios.post(
      endpoint,
      {},
      {
        headers: {
          Authorization: token,
        },
      },
    );

    return data.token;
  },
};
